import React from 'react';
import TopDayPicker from './TopDayPicker';
import TopMeteorologicalPicker from './TopMeteorologicalPicker';
import useActiveLayersStore from 'stores/useSelectedLayersStore';

const TopDateBar = ({
    startDate,
    isDatePickerDisabled,
    enabledDates,
    setStartDate,
    predictionDayProps,
    mapRef,
    layerRefs,
    updatePredictionDay,
    updateDate
}) => {

    const predictionsLayers = ["AWD", "AWP", "AWR", "DFM", "FWI", "HI", "UTCI"];
    const selectedLayers = useActiveLayersStore((state) => state.selectedLayers);
    const isPredictionActive = selectedLayers.some((layer) => predictionsLayers.includes(layer)); // We check if we're working with predictions.

    return (
        <div className='datepickers'>
            <TopDayPicker
                selectedDate={startDate}
                isDatePickerDisabled={isDatePickerDisabled}
                enabledDates={enabledDates}
                setSelectedDate={setStartDate}
                predictionDayProps={predictionDayProps}
                mapRef={mapRef}
                layerRefs={layerRefs}
                updateDate={updateDate}
            />

            {
                startDate && isPredictionActive && (
                    <TopMeteorologicalPicker
                        selectedDate={startDate}
                        predictionDayProps={predictionDayProps}
                        updatePredictionDay={updatePredictionDay}
                    />
                )
            }
        </div>
    )
}

export default TopDateBar;